/* v8 ignore start */
import { BaseGlobalState } from '@vs/rtk/slices/genericGlobal';
import { TypedUseSelectorHook, useSelector } from 'react-redux';

export const useStateSelector: TypedUseSelectorHook<{
  general: BaseGlobalState;
}> = useSelector;
/* v8 ignore stop */
